import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderContext } from '@/modules/order/context/OrderContext.tsx';
import { CustomProductsForms } from '@/shared/forms/CustomProductsForm/CustomProductsForm.tsx';
import { getCustomProductsDefaultValues } from '@/shared/forms/CustomProductsForm/domain/getCustomProductsDefaultValues.ts';
import { CustomProduct } from '@/shared/forms/CustomProductsForm/schemas/getCustomProductsFormSchema.ts';
import { convertToProductConfigurations } from '@/shared/forms/CustomProductsForm/domain/convertToProductConfigurations.ts';

type ManualOrderProductSelectionProps = {
    onContinue: () => void;
    onClearSelection: () => void;
};

export function ManualOrderProductSelection({ onContinue, onClearSelection }: ManualOrderProductSelectionProps) {
    const { t } = useTranslation();
    const { processingType, contextData, isPositionOrder, position } = useOrderContext();

    const formData = contextData.getFormData();
    const customerInfo = contextData.getCustomerInformation();
    const businessCase = contextData.getBusinessCase();
    const productConfigurations = contextData.getProductConfigurations();

    const handleSubmit = useCallback(
        (customProducts: CustomProduct[]) => {
            contextData.setProductConfigurations(convertToProductConfigurations(customProducts, processingType));
            onContinue();
        },
        [contextData, onContinue, processingType]
    );

    if (!businessCase || !customerInfo) return;

    return (
        <CustomProductsForms
            scope="ORDER"
            hideDeleteAllProductsButton={isPositionOrder}
            formRules={{ disableAllProductsUnits: isPositionOrder }}
            businessCase={businessCase}
            customerOrganizationId={customerInfo.organizationId}
            defaultValues={getCustomProductsDefaultValues(productConfigurations, position?.productConfigurations)}
            defaultBillingUnit={formData?.billingUnit}
            onSubmit={handleSubmit}
            onClearSelection={onClearSelection}
            submitButtonLabel={t('product.productTemplates.toSummaryBtn')}
            mode="create"
        />
    );
}
